export const DashboardActionTypes = {
  API_RESPONSE_SUCCESS: '@@dashboard/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@dashboard/API_RESPONSE_ERROR',

  GET_ACTIVE_OFFICES: '@@dashboard/GET_ACTIVE_OFFICES',
  GET_REGISTERED_VISITS: '@@dashboard/GET_REGISTERED_VISITS',
  GET_VISITS_BY_COUNTRY: '@@dashboard/GET_VISITS_BY_COUNTRY',
  GET_VISITS_BY_REGION: '@@dashboard/GET_VISITS_BY_REGION',
  GET_INFO_SENDED: '@@dashboard/GET_INFO_SENDED',

  RESET: '@@dashboard/RESET'
}
